import { GET_BEFORE_DAY_ORDER_TYPES } from '../actions/types';

const initialState = {
  types: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BEFORE_DAY_ORDER_TYPES:
      return {
        ...state,
        types: action.payload,
      };
    default:
      return state;
  }
};
